export const COUNTRY_OPTIONS = [
  { code: "AF", label: "Afghanistan (افغانستان)" },
  { code: "AL", label: "Albania (Shqipëri)" },
  { code: "DZ", label: "Algeria (الجزائر)" },
  { code: "AS", label: "American Samoa" },
  { code: "AD", label: "Andorra" },
  { code: "AO", label: "Angola" },
  { code: "AI", label: "Anguilla" },
  { code: "AG", label: "Antigua and Barbuda" },
  { code: "AR", label: "Argentina" },
  { code: "AM", label: "Armenia (Հայաստան)" },
  { code: "AW", label: "Aruba" },
  { code: "AU", label: "Australia" },
  { code: "AT", label: "Austria (Österreich)" },
  { code: "AZ", label: "Azerbaijan (Azərbaycan)" },
  { code: "BS", label: "Bahamas" },
  { code: "BH", label: "Bahrain (البحرين)" },
  { code: "BD", label: "Bangladesh (বাংলাদেশ)" },
  { code: "BB", label: "Barbados" },
  { code: "BY", label: "Belarus (Беларусь)" },
  { code: "BE", label: "Belgium (België)" },
  { code: "BZ", label: "Belize" },
  { code: "BJ", label: "Benin (Bénin)" },
  { code: "BM", label: "Bermuda" },
  { code: "BT", label: "Bhutan (འབྲུག)" },
  { code: "BO", label: "Bolivia" },
  { code: "BA", label: "Bosnia and Herzegovina (Босна и Херцеговина)" },
  { code: "BW", label: "Botswana" },
  { code: "BR", label: "Brazil (Brasil)" },
  { code: "VG", label: "British Virgin Islands" },
  { code: "BN", label: "Brunei" },
  { code: "BG", label: "Bulgaria (България)" },
  { code: "BF", label: "Burkina Faso" },
  { code: "BI", label: "Burundi (Uburundi)" },
  { code: "KH", label: "Cambodia (កម្ពុជា)" },
  { code: "CM", label: "Cameroon (Cameroun)" },
  { code: "CA", label: "Canada" },
  { code: "CV", label: "Cape Verde (Kabu Verdi)" },
  { code: "KY", label: "Cayman Islands" },
  { code: "CF", label: "Central African Republic (République centrafricaine)" },
  { code: "TD", label: "Chad (Tchad)" },
  { code: "CL", label: "Chile" },
  { code: "CN", label: "China (中国)" },
  { code: "CO", label: "Colombia" },
  { code: "KM", label: "Comoros (جزر القمر)" },
  { code: "CD", label: "Congo (DRC)" },
  { code: "CG", label: "Congo (Republic)" },
  { code: "CR", label: "Costa Rica" },
  { code: "CI", label: "Côte d’Ivoire" },
  { code: "HR", label: "Croatia (Hrvatska)" },
  { code: "CU", label: "Cuba" },
  { code: "CY", label: "Cyprus (Κύπρος)" },
  { code: "CZ", label: "Czech Republic (Česká republika)" },
  { code: "DK", label: "Denmark (Danmark)" },
  { code: "DJ", label: "Djibouti" },
  { code: "DM", label: "Dominica" },
  { code: "DO", label: "Dominican Republic (República Dominicana)" },
  { code: "EC", label: "Ecuador" },
  { code: "EG", label: "Egypt (مصر)" },
  { code: "SV", label: "El Salvador" },
  { code: "EE", label: "Estonia (Eesti)" },
  { code: "ET", label: "Ethiopia" },
  { code: "FJ", label: "Fiji" },
  { code: "FI", label: "Finland (Suomi)" },
  { code: "FR", label: "France" },
  { code: "GE", label: "Georgia (საქართველო)" },
  { code: "DE", label: "Germany (Deutschland)" },
  { code: "GH", label: "Ghana" },
  { code: "GR", label: "Greece (Ελλάδα)" },
  { code: "GT", label: "Guatemala" },
  { code: "HT", label: "Haiti" },
  { code: "HN", label: "Honduras" },
  { code: "HK", label: "Hong Kong (香港)" },
  { code: "HU", label: "Hungary (Magyarország)" },
  { code: "IS", label: "Iceland (Ísland)" },
  { code: "IN", label: "India (भारत)" },
  { code: "ID", label: "Indonesia" },
  { code: "IR", label: "Iran (ایران)" },
  { code: "IQ", label: "Iraq (العراق)" },
  { code: "IE", label: "Ireland" },
  { code: "IL", label: "Israel (ישראל)" },
  { code: "IT", label: "Italy (Italia)" },
  { code: "JM", label: "Jamaica" },
  { code: "JP", label: "Japan (日本)" },
  { code: "JO", label: "Jordan (الأردن)" },
  { code: "KZ", label: "Kazakhstan (Казахстан)" },
  { code: "KE", label: "Kenya" },
  { code: "KW", label: "Kuwait (الكويت)" },
  { code: "KG", label: "Kyrgyzstan (Кыргызстан)" },
  { code: "LA", label: "Laos (ລາວ)" },
  { code: "LV", label: "Latvia (Latvija)" },
  { code: "LB", label: "Lebanon (لبنان)" },
  { code: "LT", label: "Lithuania (Lietuva)" },
  { code: "LU", label: "Luxembourg" },
  { code: "MO", label: "Macau (澳門)" },
  { code: "MG", label: "Madagascar (Madagasikara)" },
  { code: "MW", label: "Malawi" },
  { code: "MY", label: "Malaysia" },
  { code: "MV", label: "Maldives" },
  { code: "ML", label: "Mali" },
  { code: "MT", label: "Malta" },
  { code: "MQ", label: "Martinique" },
  { code: "MR", label: "Mauritania (موريتانيا)" },
  { code: "MU", label: "Mauritius (Moris)" },
  { code: "MX", label: "Mexico (México)" },
  { code: "MD", label: "Moldova (Republica Moldova)" },
  { code: "MC", label: "Monaco" },
  { code: "MN", label: "Mongolia (Монгол)" },
  { code: "ME", label: "Montenegro (Crna Gora)" },
  { code: "MA", label: "Morocco (المغرب)" },
  { code: "MZ", label: "Mozambique (Moçambique)" },
  { code: "MM", label: "Myanmar (Burma) (မြန်မာ)" },
  { code: "NA", label: "Namibia (Namibië)" },
  { code: "NP", label: "Nepal (नेपाल)" },
  { code: "NL", label: "Netherlands (Nederland)" },
  { code: "NZ", label: "New Zealand" },
  { code: "NI", label: "Nicaragua" },
  { code: "NE", label: "Niger (Nijar)" },
  { code: "NG", label: "Nigeria" },
  { code: "KP", label: "North Korea" },
  { code: "NO", label: "Norway (Norge)" },
  { code: "OM", label: "Oman (عُمان)" },
  { code: "PK", label: "Pakistan (پاکستان)" },
  { code: "PA", label: "Panama (Panamá)" },
  { code: "PY", label: "Paraguay" },
  { code: "PE", label: "Peru (Perú)" },
  { code: "PH", label: "Philippines" },
  { code: "PL", label: "Poland (Polska)" },
  { code: "PT", label: "Portugal" },
  { code: "PR", label: "Puerto Rico" },
  { code: "QA", label: "Qatar (قطر)" },
  { code: "RO", label: "Romania (România)" },
  { code: "RU", label: "Russia (Россия)" },
  { code: "RW", label: "Rwanda" },
  { code: "SA", label: "Saudi Arabia (المملكة العربية السعودية)" },
  { code: "SN", label: "Senegal (Sénégal)" },
  { code: "RS", label: "Serbia (Србија)" },
  { code: "SG", label: "Singapore" },
  { code: "SK", label: "Slovakia (Slovensko)" },
  { code: "SI", label: "Slovenia (Slovenija)" },
  { code: "SO", label: "Somalia (Soomaaliya)" },
  { code: "ZA", label: "South Africa" },
  { code: "KR", label: "South Korea (대한민국)" },
  { code: "ES", label: "Spain (España)" },
  { code: "LK", label: "Sri Lanka (ශ්‍රී ලංකාව)" },
  { code: "SD", label: "Sudan (السودان)" },
  { code: "SE", label: "Sweden (Sverige)" },
  { code: "CH", label: "Switzerland (Schweiz)" },
  { code: "SY", label: "Syria (سوريا)" },
  { code: "TW", label: "Taiwan (台灣)" },
  { code: "TJ", label: "Tajikistan" },
  { code: "TZ", label: "Tanzania" },
  { code: "TH", label: "Thailand (ไทย)" },
  { code: "TN", label: "Tunisia (تونس)" },
  { code: "TR", label: "Turkey (Türkiye)" },
  { code: "UG", label: "Uganda" },
  { code: "UA", label: "Ukraine (Україна)" },
  { code: "AE", label: "United Arab Emirates (الإمارات العربية المتحدة)" },
  { code: "GB", label: "United Kingdom" },
  { code: "US", label: "United States" },
  { code: "UY", label: "Uruguay" },
  { code: "UZ", label: "Uzbekistan (Oʻzbekiston)" },
  { code: "VE", label: "Venezuela" },
  { code: "VN", label: "Vietnam (Việt Nam)" },
  { code: "YE", label: "Yemen (اليمن)" },
  { code: "ZM", label: "Zambia" },
  { code: "ZW", label: "Zimbabwe" },
];

export const DEFAULT_COUNTRY_CODE = "US";
export const DEFAULT_PHONE_PREFIX = "+1";

export const COUNTRY_DIAL_PREFIX = {
  US: "+1",
  CA: "+1",
  GB: "+44",
  AU: "+61",
  NZ: "+64",
  DE: "+49",
  FR: "+33",
  ES: "+34",
  IT: "+39",
  NL: "+31",
  BE: "+32",
  CH: "+41",
  AT: "+43",
  SE: "+46",
  NO: "+47",
  DK: "+45",
  FI: "+358",
  IE: "+353",
  PT: "+351",
  PL: "+48",
  CZ: "+420",
  HU: "+36",
  RO: "+40",
  GR: "+30",
  TR: "+90",
  RU: "+7",
  UA: "+380",
  IN: "+91",
  PK: "+92",
  BD: "+880",
  CN: "+86",
  JP: "+81",
  KR: "+82",
  HK: "+852",
  SG: "+65",
  MY: "+60",
  ID: "+62",
  TH: "+66",
  VN: "+84",
  PH: "+63",
  AE: "+971",
  SA: "+966",
  QA: "+974",
  KW: "+965",
  EG: "+20",
  MA: "+212",
  ZA: "+27",
  NG: "+234",
  KE: "+254",
  GH: "+233",
  MX: "+52",
  BR: "+55",
  AR: "+54",
  CL: "+56",
  CO: "+57",
  PE: "+51",
  VE: "+58",
  UY: "+598",
};
